<template>
  <BlSheetMv
    :active="isShowTransaction"
    auto-height
    :is-draggable="false"
    title="Kelas yang kamu ikuti"
    class="bl-sheet"
    data-test-id="transaction-sheet"
    @close="closeModal"
  >
    <div slot="content" data-test-id="content">
      <div
        class="gamification-transaction-body"
        data-test-id="transaction-body"
        :class="transactionList.length > 0 ? 'bg-color-grey' : 'bg-color-white'"
      >
        <div v-if="transactionList.length > 0">
          <div v-for="transaction in transactionList" :key="transaction.id" class="mb-16" data-test-id="transaction-item">
            <TransactionCardItem :transaction="transaction" />
          </div>
        </div>
        <div v-else data-testid="empty-section">
          <div class="flex justify-between">
            <div>
              <BlTextAv variation="subheading-18" weight="bold">Belum ada kelas yang kamu ikuti</BlTextAv>
              <BlTextAv variation="body-14" class="mt-8">Mulai ikuti dan selesalikan kelas untuk dapat hadiah e-wallet!</BlTextAv>
            </div>
            <img :src="$publicUrl('images/kartu-prakerja/question-icon.webp')" alt="question-icon" loading="lazy" width="64" height="64" />
          </div>
          <div class="mt-16">
            <BlButtonAv class="btn-lihat-kelas-lain" data-testid="btn-lihat-kelas-lain" fullwidth @click="onClickShowKelasLain">
              Lihat pilihan kelas
            </BlButtonAv>
          </div>
        </div>
      </div>
    </div>
  </BlSheetMv>
</template>

<script>
import BlSheetMv from '../temporary-bazaar-components/BlSheetMv/BlSheetMv.vue';
import TransactionCardItem from './TransactionCardItem.vue';
import {BlButtonAv, BlTextAv} from '@bukalapak/bazaar-mweb-latest';

export default {
  name: 'PrakerjaGamificationTransactionList',
  components: {
    BlSheetMv,
    TransactionCardItem,
    BlButtonAv,
    BlTextAv,
  },
  props: {
    isShowTransaction: {
      type: Boolean,
      required: true,
    },
    eligibleCampaignId: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      transactionList: [],
    };
  },
  mounted() {
    this.$api
      .getPrakerjaGamificationCampaignTransactions({
        id: this.eligibleCampaignId,
      })
      .then(({data}) => {
        this.transactionList = data;
      })
      .catch(() => {
        this.transactionList = [];
      });
  },
  methods: {
    init() {
      this.$api
        .getPrakerjaGamificationCampaignTransactions({
          id: this.eligibleCampaignId,
        })
        .then(({data}) => {
          this.transactionList = data;
        })
        .catch(() => {
          this.transactionDetail = null;
        });
    },
    closeModal() {
      this.$emit('onUpdateShowModal', false);
    },
    onClickShowKelasLain() {
      this.$router.push({
        name: 'closest-course',
        from: 'prakerja-gamification-home',
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.bl-sheet {
  max-width: 480px;
  margin: 0 auto;
}
.gamification-transaction-body {
  padding: 16px;
}
.bg-color-grey {
  background: #f2f2f2;
}
.bg-color-white {
  background: #ffffff;
}

.btn-lihat-kelas-lain {
  background: #332f9e;
  border-radius: 100px;
  border: 2px solid #332f9e;
}
.btn-lihat-kelas-lain:active {
  background: #4743c9;
  border-color: #4743c9;
}
.btn-lihat-kelas-lain:hover {
  background: #4743c9;
  border-color: #4743c9;
}
</style>
